import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

import { MobileAuthService } from '../services';

@Injectable({ providedIn: 'root' })
export class OnboardedGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: MobileAuthService,
  ) {}
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const onboarded = localStorage.getItem('onboarded') === 'true';

    // If user hasn't finished onboarding, always send to onboarding
    if (!onboarded) {
      // Already on /on-boarding? Allow, else redirect.
      if (state.url === '/on-boarding') return of(true);
      return of(this.router.createUrlTree(['/on-boarding']));
    }

    return this.authService.check().pipe(
      map((authenticated) => {
        if (authenticated) {
          // If already on /discover, allow; else redirect.
          return state.url === '/discover'
            ? true
            : this.router.createUrlTree(['/discover']);
        } else {
          // If already on /auth, allow; else redirect.
          return state.url.startsWith('/auth')
            ? true
            : this.router.createUrlTree(['/auth']);
        }
      }),
    );
  }
}
